const relatedTargetClassNames = [
  "DayPicker-TodayButton",
  "DayPicker-Day",
  "DayPicker-wrapper",
  "DayPicker-Day DayPicker-Day--disabled",
  "DayPicker-Day DayPicker-Day--outside",
  "DayPicker-Day DayPicker-Day--today",
];
const relatedTargetNames = ["year", "month"];

export function isDatepicker(target: HTMLInputElement) {
  return relatedTargetNames.includes(target.name) || relatedTargetClassNames.includes(target.className);
}
